import { PlayerAPI } from "../../../../src/apis/PlayerAPI"
import { Col, Row } from "react-bootstrap"
import { PlayerProfile } from "@components/Player/PlayerProfile/PlayerProfile"
import { getNavigationPropsForPlayer } from "@components/Navigation/getNavigationProps"
import { SEO } from "../../../../src/types/next.js"
import { ParsedUrlQuery } from "querystring"
import { GetStaticPropsContext } from "next"
import InferNextPropsType from "infer-next-props-type"
import * as NextConstants from "constants/next"
import { PlayerMenu } from "@components/Player/PlayerMenu/PlayerMenu"
import React from "react"
import { getPlayerCanonicalData } from "../../../../src/utils/player"
import { orderBy } from "lodash"

export default function PlayerPage({
  player,
  teams,
  playerCompetitionSeasonStats,
}: InferNextPropsType<typeof getStaticProps>) {
  return (
    <Row className={"marginZero"}>
      <Col md={12} className="paddingZero">
        <div id="hs-content paddingFive">
          <Row>
            <PlayerProfile teams={teams} player={player} />
          </Row>
          <PlayerMenu
            player={player}
            selected="bilancio-arbitro"
            playerCalciocomSlug={player.calciocomSlug!}
            playerCompetitionSeasonStats={playerCompetitionSeasonStats}
          />
        </div>
      </Col>
    </Row>
  )
}

export async function getStaticPaths() {
  return { paths: [], fallback: "blocking" }
}

interface IParams extends ParsedUrlQuery {
  playerCalciocomSlug: string
}

export async function getStaticProps(context: GetStaticPropsContext<IParams>) {
  try {
    const { playerCalciocomSlug } = context.params!

    const [player] = await Promise.all([PlayerAPI.getPlayerByCalciocomSlug(playerCalciocomSlug)])

    const [teams, comparison, navigationProps, playerCanonicalData, playerCompetitionSeasonStats] = await Promise.all([
      PlayerAPI.getPlayerTeams(player.id),
      PlayerAPI.getRefereeComparisionStats(player.id),
      getNavigationPropsForPlayer(player),
      getPlayerCanonicalData(player, `/giocatori/${playerCalciocomSlug}/bilancio-arbitro`),
      PlayerAPI.getPlayerCompetitionSeasonStats(player.id),
    ])

    const playerCompetitionSeasonStatsOrdered = orderBy(
      playerCompetitionSeasonStats,
      (item) => item.competitionSeason.season?.year,
      ["desc"],
    )

    const title = `${player.name}: Bilancio arbitro e cartellini ricevuti`
    const seo: SEO = {
      title: title,
      description: `Le statistiche dei cartellini gialli e rossi ricevuti da ${player.name} nel corso della sua carriera calcistica, nelle partite di campionato e di coppa.`,
      keywords: [
        `${player.name}`,
        ...[
          ...new Set(
            teams
              .filter((seasonTeamPlayer) => {
                return !!seasonTeamPlayer.team
              })
              .map((t) => t.team!.name),
          ),
        ],
        "calcio",
        "Giocatori",
        "Profilo",
        "Statistiche",
      ],
      type: "article",
      image: player.image?.path || null,
      url: `https://www.calcio.com/giocatori/${playerCalciocomSlug}`,
      ...playerCanonicalData,
    }
    return {
      props: {
        player,
        teams,
        comparison,
        navigationProps: navigationProps,
        playerCompetitionSeasonStats: playerCompetitionSeasonStatsOrdered,
        title,
        seo,
      },
      revalidate: NextConstants.REVALIDATE,
    }
  } catch (error) {
    console.error(error)
    return {
      notFound: true,
    }
  }
}
